import cc from "classcat"
import Students from "images/statistics/Students"
import Girls from "images/statistics/Girls"
import useTranslations from "hooks/useTranslations"
import { getStrokeDasharray } from "utils/svg"

const isOdd = (number) => number % 2 === 1

const FactWithImage = ({
  factText1,
  factText2,
  factText3,
  percentage,
  Image,
  number,
}) => {
  const odd = isOdd(number)

  return (
    <div
      className={cc([
        "flex items-center",
        odd ? "flex-row" : "flex-row-reverse",
      ])}
    >
      <div className="text-left text-xl leading-7 text-zinc-800">
        {factText1}
        <span className="font-display text-2xl font-bold text-kkm-yellow">
          {factText2}
        </span>
        {factText3}
      </div>
      <div className="max-w-1/2">
        <Image
          className={cc(["h-28 md:h-40", odd ? "ml-4" : "mr-4"])}
          strokeDasharray={getStrokeDasharray(percentage)}
          strokeDashoffset={0}
        />
      </div>
    </div>
  )
}

export default function Statistics() {
  const {
    schoolFactGirls1,
    schoolFactGirls2,
    schoolFactGirls3,
    schoolFactGirlsPercentage,
    schoolFactStudents1,
    schoolFactStudents2,
    schoolFactStudents3,
    schoolFactStudentsPercentage,
  } = useTranslations()

  const facts = {
    girls: {
      factText1: schoolFactGirls1,
      factText2: schoolFactGirls2,
      factText3: schoolFactGirls3,
      percentage: schoolFactGirlsPercentage,
      Image: Girls,
    },
    students: {
      factText1: schoolFactStudents1,
      factText2: schoolFactStudents2,
      factText3: schoolFactStudents3,
      percentage: schoolFactStudentsPercentage,
      Image: Students,
    },
  }

  return (
    <div className="relative">
      <div className="mx-auto space-y-8 py-8 md:space-y-12">
        <div className="grid gap-6">
          {Object.entries(facts).map(([name, fact], index) => (
            <FactWithImage {...fact} number={index} key={name} />
          ))}
        </div>
      </div>
    </div>
  )
}
